import React from 'react';
import { TestResultDc } from '@ecosconnect/core/src/types/jobFormData';
import AccordionItem from '../../../Accordion/AccordionItem';
import { formatDecimal } from '@ecosconnect/core/src/helpers/number';
import PropTypes from 'prop-types';

const DcTestResult: React.FC<{ test: TestResultDc }> = ({ test }) => {
  return (
    <>
      <AccordionItem
        required
        label="Check 1"
        value={formatDecimal(test.check1)}
      />
      <AccordionItem
        required
        label="Check 2"
        value={formatDecimal(test.check2)}
      />
    </>
  );
};

DcTestResult.propTypes = {
  test: PropTypes.any.isRequired,
};

export default DcTestResult;
